export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
        ],
        searchFields: [
            {
                name: "personName",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "gdprId",
                label: "GDPR azonosító",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "emailAddress",
                label: "E-mail",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "personName",
                label: "Név",
                sort: true,
            },
            {
                name: "gdprId",
                label: "GDPR azonosító",
                sort: true,
            },
            {
                name: "emailAddress",
                label: "E-mail",
                visibility: true,
                sort: true,
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            }
        ]
    }
}
